<ng-container [formGroup]="form">
    <div [formGroupName]="question.groupName" [ngClass]="question.styles">
        <mat-radio-group
            class="ca-radio-group"
            [formControlName]="question.questions[0].key"
            appearance="outline"
            [id]="question.questions[0].key"
        >
            @for(option of question.questions[0].options; track option){
            <div class="ca-custom-answer-radio-option">
                <mat-radio-button
                    [disableRipple]="true"
                    [value]="option.value"
                    [disabled]="option.disabled || question.questions[0].disabled"
                    [id]="question.questions[0].key + option.value"
                    [attr.data-testid]="question.questions[0].key + option.value"
                    [ngClass]="{
                        'ca-custom-radio-error': isGroupInvalid && isGroupTouched && !option.disabled,
                        'ca-radio-disabled': option.disabled || question.questions[0].disabled
                    }"
                >
                    @if(option.icon){
                    <ca-icon [icon]="option.icon" class=""></ca-icon>
                    }
                    <span>{{ option.key | translate }}</span></mat-radio-button
                >
                @if(question.customAnswerOptionValue === option.value && question.customAnswerOptionValue === radio.value){
                <mat-form-field
                    [hideRequiredMarker]="true"
                    class="ca-form-field w-full mt-2"
                    appearance="outline"
                    [class.with-label]="question.questions[1].label | translate"
                    [class.mat-form-field-invalid]="(isGroupInvalid && isGroupTouched) || (isTextInvalid && isTextTouched)"
                    [class.with-wrapped-error-message]="question.questions[1].validators.length && !(isGroupInvalid && isGroupTouched)"
                    [class.ca-form-field-value]="question.questions[1].value"
                    [ngClass]="question.questions[1].styles"
                >
                    @if(question.questions[1].label){
                    <mat-label [attr.for]="question.questions[1].key">{{ question.questions[1].label | translate }}</mat-label>
                    }
                    <input
                        [placeholder]="question.questions[1].placeholder | translate"
                        [formControlName]="question.questions[1].key"
                        [id]="question.questions[1].key"
                        [attr.data-testid]="question.questions[1].key"
                        [type]="question.questions[1].type"
                        [mask]="(question.questions[1] | as : TYPES.TextboxQuestion).mask.pattern"
                        [patterns]="$any(question.questions[1]).mask?.customPatterns"
                        [decimalMarker]="$any(question.questions[1]).mask?.decimalMarker"
                        [separatorLimit]="$any(question.questions[1]).mask?.separatorLimit"
                        [suffix]="' ' + (question.questions[1].suffix | translate)"
                        matInput
                    />
                    @if(question.questions[1].permanentHint && !(isGroupInvalid && isGroupTouched)){
                    <mat-hint @slideDown> {{ question.questions[1].permanentHint | translate }}</mat-hint>
                    } @if(isTextTouched && !(isGroupInvalid && isGroupTouched)){
                    <mat-error>
                        <ca-form-error-message>
                            {{ textErrorMessage | translate }}
                        </ca-form-error-message>
                    </mat-error>
                    }
                </mat-form-field>
                }
            </div>
            }
        </mat-radio-group>
        @if(question.validators.length){
        <div class="ca-subscript relative mt-2">
            @if(isGroupInvalid && isGroupTouched){
            <div class="absolute ca-error-message" @slideDown>
                <ca-form-error-message>
                    {{ groupErrorMessage | translate }}
                </ca-form-error-message>
            </div>
            }
        </div>
        }
    </div>
</ng-container>
